<template>
  <div class="w-100 greenmatch">
    <main-hero />
    <div class="row">
      <div class="col">
        <register-form :brand="brand" />
        <register-section-leads />
        <register-section-why-us />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import MainHero from "@/components/section/MainHero";
import AppFooter from "@/components/footer/AppFooter";
import RegisterForm from '@/components/form/Register';
import RegisterSectionLeads from "@/components/section/RegisterSectionLeads";
import RegisterSectionWhyUs from "@/components/section/RegisterSectionWhyUs";
import '@/styles/theme/greenmatch/register.scss';
import store from "@/store";

export default {
  name: "RegisterBrand",
  components: {AppFooter, MainHero, RegisterForm, RegisterSectionWhyUs, RegisterSectionLeads},
  data() {
    return {
      brand: {
        key: 'greenmatch',
        brandName: "GreenMatch",
        registerFormHeading: "Become a GreenMatch Partner",
        region: "gb",
        language: "en",
        additional: {}
      },
    };
  },
  beforeRouteEnter: function (to, from, next) {
    if (store.state.USER_STATE === true) {
      next({name:'dashboard'});
    } else {
      next();
    }
  },
}
</script>

<style scoped lang="scss">

</style>
